import React from 'react';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type ArticulV1Props = {
    productCard: ShowableProductCard;
}

const ArticulV1 = observer(({ productCard }: ArticulV1Props) => {
    if (!productCard || !productCard.articul) {
        return null;
    }

    return (
        <>
            Артикул: {productCard.articul.value}
        </>
    );
});

export default ArticulV1;
